import { api } from "../Configurations/axios";

const GetAllLinesAssignedAPI = async (companyId: string, year: number | undefined) => {
    try {
        var result = await api.get(`/Home/GetAllLinesAssigned/?companyId=${companyId}&year=${year ?? ""}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetValuesToGaugeAPI = async (companyId: string, yearProject: number | undefined, yearAnalysis: number | undefined) => {
    try {
        var result = await api.get(`/Home/GetValuesToGauge/?companyId=${companyId}&yearProject=${yearProject ?? ""}&yearAnalysis=${yearAnalysis ?? ""}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetProjectsWithBudgetAPI = async (companyId: string, year: number | undefined) => {
    try {
        var result = await api.get(`/Home/GetProjectsWithBudget/?companyId=${companyId}&year=${year ?? ""}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllAnalysisYearsAPI = async (companyId: string) => {
    try {
        var result = await api.get(`/Home/GetAllAnalysisYears/?companyId=${companyId}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllProjectsYearsAPI = async (companyId: string) => {
    try {
        var result = await api.get(`/Home/GetAllProjectsYears/?companyId=${companyId}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetAllLinesAssignedAPI,
    GetValuesToGaugeAPI,
    GetProjectsWithBudgetAPI,
    GetAllAnalysisYearsAPI,
    GetAllProjectsYearsAPI
}